import {
  deleteNote,
  getContractNotes,
  storeNote,
  updateNote
} from "../../api-helpers/contracts/api-notes";

export default {
  state: {
    isGettingContractNotes: false,
    contractNotes: null,
    isStoringNote: false,
    isUpdatingNote: false,
    idDeletingNote: false
  },
  mutations: {
    setIsGettingContractNotes(state, bool) {
      state.isGettingContractNotes = bool;
    },
    setContractNotes(state, notes) {
      state.contractNotes = notes;
    },
    setIsStoringNote(state, bool) {
      state.isStoringNote = bool;
    },
    setIsUpdatingNote(state, bool) {
      state.isUpdatingNote = bool;
    },
    setIsDeletingNote(state, bool) {
      state.idDeletingNote = bool;
    }
  },
  actions: {
    async getContractNotes({ state, commit }, contractId) {
      let contractNotes = state.contractNotes;
      if (!state.isGettingContractNotes && contractId) {
        commit("setIsGettingContractNotes", true);

        contractNotes = await getContractNotes(contractId);
        commit("setContractNotes", contractNotes);

        commit("setIsGettingContractNotes", false);
      }
      return contractNotes;
    },
    async storeNote({ state, commit, dispatch }, note) {
      let response;
      if (!state.isStoringNote) {
        commit("setIsStoringNote", true);

        response = await storeNote(note);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Note stored successfully.",
          errorText: "An error occurred while attempting to store Note.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            dispatch("getContractNotes", note.contract_id);
          }
        });

        commit("setIsStoringNote", false);
      }
      return response;
    },
    async updateNote({ state, commit, dispatch }, note) {
      let response;
      if (!state.isStoringNote) {
        commit("setIsStoringNote", true);

        response = await updateNote(note);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Note updated successfully.",
          errorText: "An error occurred while attempting to update Note.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            dispatch("getContractNotes", note.contract_id);
          }
        });

        commit("setIsStoringNote", false);
      }
      return response;
    },
    async deleteNote({ state, commit, dispatch }, note) {
      let response;
      if (!state.isStoringNote) {
        commit("setIsDeletingNote", true);

        response = await deleteNote(note);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Note deleted successfully.",
          errorText: "An error occurred while attempting to delete Note.",
          afterSuccessFunction: () => {
            commit("resetConfirmationModalParams");
            dispatch("getContractNotes", note.annotatable_id);
          }
        });

        commit("setIsDeletingNote", false);
      }
      return response;
    }
  }
};
